export default "__VITE_ASSET__DTRroIJd__"